import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { InputSelect } from '@vio/atlas/InputSelect';
import { getSortByLabels, shouldShowSortByWithDistance } from 'components/SortBy/helpers';
import { useSortBy } from 'hooks/useSortBy';
import { getSearchType } from 'modules/sapiSearch/selectors';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { SORT_BY, SORT_BY_WITH_DISTANCE, SortByTypeItem, TIERS } from './constants';
const _exp = /*#__PURE__*/() => Flex.Row;
const SortByWrapper = /*#__PURE__*/styled(_exp())({
  name: "SortByWrapper",
  class: "s1rgjmbd",
  propsAsIs: true
});
export const SortByDesktop: React.FC = () => {
  const {
    onChangeSort,
    sortParams
  } = useSortBy();
  const dispatch = useDispatch();
  const {
    formatMessage
  } = useIntl();
  const {
    sortField: sortSelectedField,
    sortOrder: sortSelectedOrder
  } = sortParams;
  const {
    brandIsVio
  } = useBrand();
  const sortLabels = getSortByLabels();
  const searchType = useSelector(getSearchType);
  const sortByList = shouldShowSortByWithDistance(searchType) ? SORT_BY_WITH_DISTANCE : SORT_BY;
  const activeSortByField = sortByList.find(item => item.sortField === sortSelectedField && item.sortOrder === sortSelectedOrder);
  const [currentSort, setCurrentSort] = React.useState(activeSortByField);
  useEffect(() => {
    setCurrentSort(activeSortByField);
  }, [activeSortByField]);
  const handleChangeSort = (newSort: string) => {
    const details = JSON.parse(newSort) as SortByTypeItem;
    if (!details) return;
    setCurrentSort(details);
    onChangeSort({
      sortField: details.sortField,
      sortOrder: details.sortOrder
    });
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement?.blur();
    }
  };
  const handleOpenList = () => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SortButton,
      action: Action.Clicked
    }));
  };
  const tier = brandIsVio ? TIERS.Gems : TIERS.PrivateDeal;
  return <SortByWrapper alignItems="center">
      <InputSelect size="sm" onChange={handleChangeSort} value={JSON.stringify(currentSort)} onClick={handleOpenList} ariaLabel={formatMessage({
      id: 'sortBy',
      defaultMessage: 'Sort by'
    })}>
        {sortByList.map(item => <option key={item.key} value={JSON.stringify(item)}>
            {formatMessage(sortLabels[item.key], {
          tier
        })}
          </option>)}
      </InputSelect>
    </SortByWrapper>;
};

require("./Desktop.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Desktop.tsx");